import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import raulImg from "../../static/media/marketing_raul_patino.webp";
import erikImg from "../../static/media/ing_erik.webp";

export default function TeamSection() {
  const containerSx = {
    position: "relative",
    backgroundColor: "#000",
    color: "#fff",
    py: { xs: 8, md: 5 },
    overflow: "hidden",
  };

  const overlaySx = {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(128,0,255,0.25) 0%, rgba(0,0,0,0.9) 100%)",
    zIndex: 1,
  };

  const wrapSx = {
    position: "relative",
    zIndex: 2,
    maxWidth: "1200px",
    mx: "auto",
    px: { xs: 3, md: 6 },
  };

  const introSx = {
    maxWidth: "900px",
    mx: "auto",
    mb: { xs: 5, md: 7 },
    textAlign: "center",
  };

  const ceoBoxSx = {
    background:
      "linear-gradient(180deg, rgba(128,0,255,0.12) 0%, rgba(128,0,255,0.03) 100%)",
    border: "1px solid rgba(128,0,255,0.28)",
    borderRadius: 4,
    p: { xs: 2.5, md: 4 },
    boxShadow: "0 12px 34px rgba(128,0,255,0.16)",
  };

  const rowSx = (reverse = false) => ({
    display: "flex",
    flexDirection: { xs: "column", md: reverse ? "row-reverse" : "row" },
    alignItems: "center",
    gap: { xs: 3, md: 6 },
    py: { xs: 4, md: 6 },
  });

  const imgWrapperSx = {
    width: { xs: "100%", md: "46%" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const imgSx = {
    width: { xs: "80%", sm: "70%", md: "80%" },
    maxHeight: { xs: 350, sm: 400, md: 460 },
    borderRadius: 4,
    objectFit: "cover",
    boxShadow: "0 20px 50px rgba(128,0,255,0.25)",
    outline: "1px solid rgba(128,0,255,0.35)",
    filter: "drop-shadow(0 0 18px rgba(128,0,255,0.35))",
  };

  const textSx = {
    width: { xs: "100%", md: "54%" },
  };

  const nameSx = {
    fontWeight: 600,
    fontSize: { xs: "1.6rem", md: "2rem" },
    lineHeight: 1.1,
    color: "#8000FF",
    mb: 0.5,
  };

  const roleSx = {
    fontWeight: 500,
    fontSize: { xs: "1rem", md: "1.1rem" },
    color: "#aebac1",
    mb: 2,
  };

  const quoteSx = {
    fontSize: { xs: "0.95rem", md: "1.05rem" },
    lineHeight: { xs: 1.6, md: 1.7 },
    color: "#fff",
    background:
      "linear-gradient(180deg, rgba(128,0,255,0.07) 0%, rgba(128,0,255,0.02) 100%)",
    border: "1px solid rgba(128,0,255,0.2)",
    borderRadius: 3,
    p: { xs: 2, md: 3 },
    boxShadow: "0 8px 24px rgba(128,0,255,0.15)",
  };

  return (
    <Box id="equipo" sx={containerSx}>
      <Box sx={overlaySx} />

      <Box sx={wrapSx}>
        <Typography
          component={motion.h2}
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          sx={{
            textAlign: "center",
            fontWeight: 600,
            color: "#8000FF",
            fontSize: { xs: "1.8rem", md: "2.4rem" },
            mb: { xs: 4, md: 6 },
          }}
        >
          Equipo Directivo DobleDx
        </Typography>

        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 45 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
          sx={introSx}
        >
          <Box sx={ceoBoxSx}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.4rem", md: "1.9rem" },
                lineHeight: 1.15,
                color: "#8000FF",
                mb: 1,
              }}
            >
              CEO DobleDx
            </Typography>

            <Typography
              sx={{
                fontWeight: 500,
                fontSize: { xs: "0.95rem", md: "1.05rem" },
                lineHeight: 1.7,
                color: "#fff",
              }}
            >
              “Desde la dirección estratégica de DobleDx, el liderazgo se
              enfoca en construir soluciones digitales premium con visión de
              impacto, integrando tecnología, inteligencia de negocios, análisis
              de datos y generación de código experto. La propuesta se centra en
              ejecutar proyectos con precisión, visión comercial y resultados
              medibles, garantizando que cada inversión tecnológica genere un
              retorno superior a la expectativa.”
            </Typography>
          </Box>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
          sx={rowSx(false)}
        >
          <Box sx={imgWrapperSx}>
            <Box
              component="img"
              src={raulImg}
              alt="Raúl Patiño Mora"
              sx={imgSx}
            />
          </Box>

          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            viewport={{ once: true }}
            sx={textSx}
          >
            <Typography sx={nameSx}>Raúl Patiño Mora</Typography>
            <Typography sx={roleSx}>Experto Marketing Digital</Typography>
            <Typography sx={quoteSx}>
              “Como Ingeniero en Sistemas y Maestro en Marketing Digital, mi
              especialidad radica en la fusión estratégica de tecnología y
              mercado. Mi trayectoria abarca desde el desarrollo web y el
              posicionamiento SEO/SEM hasta la optimización de la experiencia
              del usuario UX, todo ello potenciado con automatización e
              inteligencia artificial. Mi enfoque integra análisis profundo,
              creatividad sin límites y una estrategia orientada a impulsar
              marcas y garantizar un impacto digital medible y superior.”
            </Typography>
          </Box>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
          sx={rowSx(true)}
        >
          <Box sx={imgWrapperSx}>
            <Box
              component="img"
              src={erikImg}
              alt="Erik Zabala Quito"
              sx={imgSx}
            />
          </Box>

          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            sx={textSx}
          >
            <Typography sx={nameSx}>Erik Zabala Quito</Typography>
            <Typography sx={roleSx}>
              Ingeniero en Sonido y Acústica
            </Typography>
            <Typography sx={quoteSx}>
              “Especialista en la gestión y ejecución de proyectos de audio
              profesional con un enfoque riguroso en la precisión técnica. Mi
              trayectoria incluye la producción de podcasts de alto nivel para
              creadores de contenido en nichos de viajes y variedades,
              optimizando la narrativa sonora para plataformas digitales. Como
              cofundador de Saint Roque Records, he liderado la creación de un
              espacio clave para la difusión musical, integrando tecnología y
              curaduría en formatos digitales. En el ámbito del sonido en vivo,
              garantizo la fidelidad acústica y el control técnico para bandas
              en diversos escenarios. Mi compromiso es claro: implementar
              procesos técnicos estructurados para asegurar la máxima calidad en
              cada etapa de la producción, desde el diseño técnico y logístico
              hasta la entrega final del evento.”
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}